/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SitemapInputs */

const en_sitemap = /** @type {(inputs: SitemapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitemap`)
};

const th_sitemap = /** @type {(inputs: SitemapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แผนผังเว็บไซต์`)
};

const ja_sitemap = /** @type {(inputs: SitemapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイトマップ`)
};

const fr_sitemap = /** @type {(inputs: SitemapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan du site`)
};

const es_sitemap = /** @type {(inputs: SitemapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa del sitio`)
};

const ru_sitemap = /** @type {(inputs: SitemapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карта сайта`)
};

const zh_sitemap = /** @type {(inputs: SitemapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网站地图`)
};

const vi_sitemap = /** @type {(inputs: SitemapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sơ đồ trang`)
};

/**
* | output |
* | --- |
* | "Sitemap" |
*
* @param {SitemapInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const sitemap = /** @type {((inputs?: SitemapInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SitemapInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sitemap(inputs)
	if (locale === "ja") return ja_sitemap(inputs)
	if (locale === "fr") return fr_sitemap(inputs)
	if (locale === "es") return es_sitemap(inputs)
	if (locale === "ru") return ru_sitemap(inputs)
	if (locale === "zh") return zh_sitemap(inputs)
	if (locale === "vi") return vi_sitemap(inputs)
	return en_sitemap(inputs)
});